import remoteStorage from "./remoteStorageIntegration";
import { getAssortmentOptions } from "./wbsIntegration";
import { getTranslations } from "@/utils/helpers";
import { isEmpty } from "lodash";

let assortment_initialized = false;
let assortment_initializing = false;

export function setupRemoteStorageAssortment(
  allProducts,
  setProducts,
  store,
  options = {}
) {
  let assortmentOptions = getAssortmentOptions();
  if (assortmentOptions.enabled) {
    console.log("remotestorage - setupRemoteStorageAssortment enabled");
    if (assortment_initialized) {
      console.log("remotestorage - assortment already initialized");
      return Promise.resolve({ ok: true, status: "already_initialized" });
    }
    assortment_initialized = true;
    assortment_initializing = true;
    remoteStorage.init(assortmentOptions.url, assortmentOptions.apikey);
    return getProductsFromRemoteStorageAssortment(store, options).then(
      rs_assortment => {
        console.log("rs_assortment", JSON.stringify(rs_assortment));
        let products = assortmentToLocalProducts(
          rs_assortment,
          allProducts,
          assortment_initializing,
          store
        );
        setProducts(products);
        return sendProductsToRemoteStorage(allProducts, store).then(() => {
          assortment_initializing = false;
          setupRemoteStorageAssortmentUpdateHandler(
            allProducts,
            setProducts,
            store
          );
          return { ok: true, status: "initialized" };
        });
      }
    );
  } else {
    console.log("remotestorage - setupRemoteStorageAssortment disabled");
    return Promise.resolve({ ok: false, status: "disabled" });
  }
}

function getProductsFromRemoteStorageAssortment(store, options = {}) {
  let { retry = true } = options;

  let resolve_fn, reject_fn;
  let resultPromise = new Promise((resolve, reject) => {
    resolve_fn = resolve;
    reject_fn = reject;
  });

  console.log("remotestorage - getProductsFromRemoteStorageAssortment");
  let rsNamespace = "assortment";

  // retry timeout 120 seconds, retry delay 10 seconds
  let retryTimeoutMs = 120 * 1000;
  let retryDelayMs = 10 * 1000;
  let startedAt = Date.now();

  let tryGetFromRemoteStorage = () => {
    remoteStorage
      .get(rsNamespace)
      .then(response => {
        resolve_fn(response.data.value.data);
      })
      .catch(err => {
        if (retry && Date.now() - startedAt < retryTimeoutMs) {
          console.log(
            "getting products from remote storage failed, retrying..."
          );
          setTimeout(tryGetFromRemoteStorage, retryDelayMs);
          return;
        }

        console.log("getting products from remote storage failed.");
        //store.commit("LOCK", {
        //  code: "RemoteStorageTimeout",
        //  message: "Remote storage assortment retrieval timed out"
        //});
        assortment_initialized = false;
        assortment_initializing = false;
        reject_fn(err);
      });
  };

  tryGetFromRemoteStorage();
  return resultPromise;
}

function sendProductsToRemoteStorage(allProducts, store) {
  console.log("remotestorage - sendProductsToRemoteStorage");
  let assortment = productsToAssortment(allProducts, store);
  let namespace = "assortment";
  return Promise.all([
    remoteStorage.set(namespace, "products", assortment.products),
    remoteStorage.set(namespace, "extras", assortment.extras),
    remoteStorage.set(namespace, "ingredients", assortment.ingredients)
  ]);
}

function setupRemoteStorageAssortmentUpdateHandler(
  allProducts,
  setProducts,
  store
) {
  console.log("remotestorage- setupRemoteStorageAssortmentUpdateHandler");
  remoteStorage.refresh("assortment", data => {
    let products = assortmentToLocalProducts(
      data,
      allProducts,
      assortment_initializing,
      store
    );
    setProducts(products);
  });
}

function updateElem(local_elem, remote_collection, assortment_initializing) {
  let id_elem = local_elem.id;
  //We copy to initial state here for future reference!
  if (assortment_initializing) {
    local_elem.db_soldout = local_elem.soldout;
    local_elem.db_hide = local_elem.hide;
  }
  if (typeof remote_collection[id_elem] !== "undefined") {
    local_elem.soldout = remote_collection[id_elem].soldout;
    local_elem.hide = remote_collection[id_elem].hide;
  }
}

export function assortmentToLocalProducts(
  assortment,
  local_products,
  assortment_initializing,
  store
) {
  let { products, ingredients, extras } = assortment;

  store.commit("SET_INGREDIENTS", ingredients);
  store.commit("SET_EXTRAS", extras);

  let updateProduct = product =>
    updateElem(product, products, assortment_initializing);
  let updateIng = ingredient =>
    updateElem(ingredient, ingredients, assortment_initializing);
  let updateExtra = extra => updateElem(extra, extras, assortment_initializing);
  local_products.forEach(local_product => {
    updateProduct(local_product);
    // Don't update Extra Prices from Remote storage for now.
    // local_product.extras.forEach(local_extra_group => {
    //   local_extra_group.extras.forEach(local_extra => {
    //     let id_extra = local_extra.id;
    //     if (typeof extras[id_extra] !== "undefined") {
    //       local_extra.offset_price = (extras[id_extra].price / 100.0).toFixed(
    //         2
    //       );
    //     }
    //   });
    // });
    local_product.default_ingredients.forEach(updateIng);
    local_product.available_ingredient_groups.forEach(
      local_ingredient_group => {
        local_ingredient_group.ingredients.forEach(updateIng);
      }
    );
    local_product.extras.forEach(local_extra_group => {
      local_extra_group.extras.forEach(updateExtra);
    });
  });
  return local_products;
}

export function addTranslations(id, element, klass, store) {
  if (isEmpty(store)) {
    return {};
  }
  let element_translations = getTranslations(
    store,
    klass,
    "display_name",
    id,
    element.name
  );
  if (!isEmpty(element_translations)) {
    Object.assign(element, element_translations);
  }
}

export function productsToAssortment(local_products, store) {
  let products = {},
    extras = {},
    ingredients = {};
  let options = getAssortmentOptions();
  local_products.forEach(local_product => {
    if (!options.show_hidden && local_product.db_hide) {
      return;
    }

    products[local_product.id] = {
      name: local_product.name,
      db_name: local_product.db_name,
      price: local_product.price,
      soldout: local_product.soldout,
      hide: local_product.hide,
      db_soldout: local_product.db_soldout,
      db_hide: local_product.db_hide
    };
    addTranslations(
      local_product.id,
      products[local_product.id],
      "Product",
      store
    );

    local_product.extras.forEach(local_extra_group => {
      local_extra_group.extras.forEach(local_extra => {
        extras[local_extra.id] = {
          name: local_extra.name,
          db_name: local_extra.db_name,
          price: local_extra.offset_price,
          offset_price: local_extra.offset_price,
          order_by: local_extra.order_by,
          hide: local_extra.hide,
          soldout: local_extra.soldout
        };
        addTranslations(local_extra.id, extras[local_extra.id], "Extra", store);
      });
    });
    local_product.default_ingredients.forEach(local_ingredient => {
      if (local_ingredient.hide) {
        return;
      }
      ingredients[local_ingredient.id] = {
        name: local_ingredient.name,
        db_name: local_ingredient.db_name,
        price: local_ingredient.price,
        soldout: local_ingredient.soldout,
        hide: local_ingredient.hide,
        db_soldout: local_ingredient.db_soldout,
        db_hide: local_ingredient.db_hide
      };
      addTranslations(
        local_ingredient.id,
        ingredients[local_ingredient.id],
        "Ingredient",
        store
      );
    });
    local_product.available_ingredient_groups.forEach(
      local_ingredient_group => {
        if (local_ingredient_group.hide) {
          return;
        }
        local_ingredient_group.ingredients.forEach(local_ingredient => {
          ingredients[local_ingredient.id] = {
            name: local_ingredient.name,
            db_name: local_ingredient.db_name,
            price: local_ingredient.price,
            soldout: local_ingredient.soldout,
            hide: local_ingredient.hide,
            db_soldout: local_ingredient.db_soldout,
            db_hide: local_ingredient.db_hide
          };
          addTranslations(
            local_ingredient.id,
            ingredients[local_ingredient.id],
            "Ingredient",
            store
          );
        });
      }
    );
  });
  return { products, extras, ingredients };
}
